import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const pageNames = {
  "/admin/dashboard": "Dashboard",
  "/admin/sliders": "Sliders",
  "/admin/brands": "Brands",
  "/admin/home-section-products": "Home Section Products",
  "/admin/advertise-section-products": "Advertise Management",
  "/admin/all-products": "All Products",
  "/admin/active-products": "Active Products",
  "/admin/inactive-products": "Inactive Products",
  "/admin/all-sold-products": "Out of Stock Products",
  "/admin/all-offers-products": "Offer Products",
  "/admin/all-orders": "All Orders",
  "/admin/new-orders": "New Orders",
  "/admin/delivered-orders": "Delivered Orders",
  "/admin/cancelled-orders": "Cancelled Orders",
  "/admin/pending-orders": "Pending Orders",
  "/admin/transactions": "Transactions",
  "/admin/customer-management": "Customer Management",
  "/admin/contact-us-list": "Contact Us List",
  "/admin/shipping-rule": "Shipping Rule",
};

const getPageName = (pathname) => {
  if (pageNames[pathname]) {
    return pageNames[pathname];
  }

  // Dynamic routes
  if (pathname.startsWith("/admin/slider/edit/")) {
    return "Edit Slider";
  }

  if (pathname === "/admin/slider/create") {
    return "Create Slider";
  }

  if (pathname === "/admin/product/create") {
    return "Create Product";
  }

  if (pathname.startsWith("/admin/products/edit/")) {
    return "Edit Product";
  }

  if (pathname === "/admin/customer/create") {
    return "Create Customer";
  }

  // Fallback
  const lastPart = pathname.split("/").filter(Boolean).pop();

  if (!lastPart) {
    return "Dashboard";
  }

  return lastPart
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const Breadcrumb = ({ currentPage }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const pageName = currentPage || getPageName(location.pathname);

  const handleHomeClick = () => {
    navigate("/admin/dashboard");
  };

  return (
    <nav aria-label="breadcrumb">
      <ol
        className="breadcrumb mb-0"
        style={{
          gap: "0.001px",
          alignItems: "center",
        }}
      >
        <li className="breadcrumb-item">
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-none"
            onClick={handleHomeClick}
            style={{
              fontSize: "14px",
            }}
          >
            Home
          </button>
        </li>

        <li
          className="breadcrumb-item active"
          aria-current="page"
          style={{
            marginLeft: "2px",
            fontSize: "14px",
          }}
        >
          {pageName}
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;